(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-homelocation.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-homelocation.js');
"use strict";

const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom;
const mapFlyToLevelAtom = svs.lyckoplatsen.shared_map.atoms.mapFlyToLevelAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  pinLocationAtom = _svs$lyckoplatsen$com.pinLocationAtom,
  pinLocationTypeAtom = _svs$lyckoplatsen$com.pinLocationTypeAtom,
  shouldShowPinAtom = _svs$lyckoplatsen$com.shouldShowPinAtom;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_play.utils,
  askPremisionToUseHomeLocation = _svs$lyckoplatsen$com2.askPremisionToUseHomeLocation,
  showHomeLocationError = _svs$lyckoplatsen$com2.showHomeLocationError;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const logger = svs.lyckoplatsen.logger;
const useHomeLocation = () => {
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const setMapFlyToLevel = useSetAtom(mapFlyToLevelAtom);
  const setShouldShowPin = useSetAtom(shouldShowPinAtom);
  const handler = async () => {
    const extraParams = {
      product: 'lyckoplatsen',
      branding: 'lyckoplatsen',
      forceShortOnboarding: true
    };
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      const shouldSignIn = await askPremisionToUseHomeLocation();
      if (shouldSignIn) {
        setShouldShowPin(false);
        setPinLocation({
          lat: null,
          lng: null
        });
        svs.utils.paramHandler.set({
          key: 'locationHome',
          value: true
        });
        const onboardingData = {
          returnNewCustomer: true,
          extraParams
        };
        svs.components.customer_login.login(onboardingData);
      }
    } else {
      var _svs, _svs$setupExtraData;
      svs.ui.loader.show();
      await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
        extraData: extraParams
      }));
      try {
        const playerGeoLocation = svs.lyckoplatsen.data.homeLocation.playerGeoLocation;
        const _JSON$parse = JSON.parse(playerGeoLocation),
          lat = _JSON$parse.Latitude,
          lng = _JSON$parse.Longitude;
        setShouldShowPin(false);
        setPinLocationType(CONSTANTS.LOCATION_TYPES.HOME);
        setMapFlyToLevel(CONSTANTS.MAX_ZOOM_LEVEL);
        setPinLocation({
          lat,
          lng
        });
      } catch (e) {
        logger.error('Failed to resolve home location', e);
        showHomeLocationError();
      }
      svs.ui.loader.hide();
    }
  };
  return handler;
};
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks', {
  useHomeLocation
});

 })(window);